module.exports = __webpack_public_path__ + "static/media/distribution.svg";